import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import H5 from '../../typography/headers/H5'
import MarkdownLabel from '../../mini/MarkdownLabel'
import QualityApproved from '../../../static/images/icon_check_ir_approve.svg'
import QualityRejected from '../../../static/images/icon_reject_red_sm.svg'
import { capitalizeWord } from '../../../utils/string'
import TimestampVersion from './TimestampVersion'
import { ExpandedHistoryEventContainer } from './_Styled'

const QualityApprovedIcon = styled.div`
  background: url(${QualityApproved}) no-repeat;
  height: 14px;
  width: 14px;
  background-size: 100%;
  margin-right: 11px;
`

const QualityRejectedIcon = styled.div`
  background: url(${QualityRejected}) no-repeat;
  height: 14px;
  width: 14px;
  background-size: 100%;
  margin-right: 11px;
`

const ReviewTypeApprovedRejectedWrapper = styled.div`
  display: flex;
  align-items: center;
`

class QualityReviewInfo extends React.Component {
  constructor(props) {
    super(props)
    this.parentRef = props.parentRef.current
  }

  render() {
    const { event } = this.props
    return (
      <ExpandedHistoryEventContainer
        bg={getComputedStyle(this.props.parentRef.current).backgroundColor}
        style={{ padding: '26px 39px 26px 80px' }}
        comment
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'top',
            justifyContent: 'space-between',
            marginBottom: '17px'
          }}
        >
          <ReviewTypeApprovedRejectedWrapper>
            {event.metadata.approved ? (
              <QualityApprovedIcon />
            ) : (
              <QualityRejectedIcon />
            )}
            <H5>{capitalizeWord(event.metadata.criteria)}</H5>
          </ReviewTypeApprovedRejectedWrapper>
          <TimestampVersion event={event} />
        </div>
        <div style={{ marginBottom: '17px' }}>
          <MarkdownLabel value={event.comment} />
        </div>
      </ExpandedHistoryEventContainer>
    )
  }
}

QualityReviewInfo.propTypes = {
  event: PropTypes.object.isRequired,
  parentRef: PropTypes.object.isRequired
}

export default QualityReviewInfo



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/QualityReviewInfo.js